// src/components/VaultXComingSoon.js
//
// Production only (VAULTX_COMING_SOON, 2026-10-29): VaultX isn't on production
// yet, so the VaultX tile's page (/ebinder) shows this notice instead of the old
// eBinder prototype. Nothing stored in the prototype is changed or removed.
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";

export default function VaultXComingSoon() {
  const navigate = useNavigate();
  return (
    <div className="vaultx-soon-page min-h-screen bg-[#0b0820] text-slate-100 px-4 py-6 sm:px-8">
      <div className="max-w-xl mx-auto">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="vaultx-soon-back inline-flex items-center gap-1.5 px-3 py-2 rounded-xl bg-white/[0.04] border border-white/10 hover:bg-white/[0.08] text-sm text-slate-200 transition"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>
        <div className="vaultx-soon-card mt-10 rounded-2xl border border-white/10 bg-white/[0.03] p-8 text-center">
          <div className="mx-auto mb-4 w-12 h-12 rounded-2xl bg-indigo-500/20 border border-indigo-300/30 flex items-center justify-center">
            <Clock className="w-6 h-6 text-indigo-200" />
          </div>
          <h1 className="text-xl font-semibold text-white">VaultX is coming soon</h1>
          <p className="mt-2 text-sm text-slate-300">
            The paperless regulatory binder isn't available yet. We'll let you know when it's ready.
          </p>
        </div>
      </div>
    </div>
  );
}
